import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotesPage = lazy(() => import('../pages/notes/page'));
const LGSExamsPage = lazy(() => import('../pages/lgs-exams/page'));
const LGSTrackingPage = lazy(() => import('../pages/lgs-tracking/page'));
const HomeworkTrackingPage = lazy(() => import('../pages/homework-tracking/page'));
const AIEvaluationPage = lazy(() => import('../pages/ai-evaluation/page'));
const LoginPage = lazy(() => import('../pages/auth/login/page'));
const RegisterPage = lazy(() => import('../pages/auth/register/page'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const ProfilePage = lazy(() => import('../pages/profile/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/notes',
    element: <NotesPage />,
  },
  {
    path: '/lgs-exams',
    element: <LGSExamsPage />,
  },
  {
    path: '/lgs-tracking',
    element: <LGSTrackingPage />,
  },
  {
    path: '/homework-tracking',
    element: <HomeworkTrackingPage />,
  },
  {
    path: '/ai-evaluation',
    element: <AIEvaluationPage />,
  },
  {
    path: '/auth/login',
    element: <LoginPage />,
  },
  {
    path: '/auth/register',
    element: <RegisterPage />,
  },
  {
    path: '/dashboard',
    element: <DashboardPage />,
  },
  {
    path: '/profile',
    element: <ProfilePage />,
  },
  {
    path: '/admin',
    element: <AdminPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
